export enum ClientStatus {
  Normal = 1,
  Blocked = 2,
  Banned = 3,
}
